/* flux.js — page-specific behaviors for the Flux landing page.
 * Plays on top of sk2.js and gr.js (do not duplicate carousel/hero/wordmark logic here).
 *
 * Provides:
 *   - Tier filter for flux-shop-rims (3-state pill above the inner tab strip).
 *   - Tab filter for flux-specs-wheels / flux-specs-rims.
 *   - Video swap for flux-compliance tabs.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function initRimShop(root) {
    var rimPill = root.querySelector('[data-flux-rim-pill]');
    var track = root.querySelector('[data-shop-track]');
    var allTabs = Array.prototype.slice.call(root.querySelectorAll('[data-shop-tab]'));
    var allSlides = Array.prototype.slice.call(root.querySelectorAll('[data-shop-slide]'));
    var prevBtn = root.querySelector('[data-shop-prev]');
    var nextBtn = root.querySelector('[data-shop-next]');
    var tierBtns = root.querySelectorAll('[data-flux-tier]');
    var slidingPill = root.querySelector('[data-flux-tier-pill]');
    if (!rimPill || !tierBtns.length || !track) return;

    var visibleTabs = [];
    var visibleSlides = [];
    var current = 0;

    function moveTierPill(btn) {
      if (!slidingPill || !btn) return;
      var pRect = btn.parentElement.getBoundingClientRect();
      var bRect = btn.getBoundingClientRect();
      slidingPill.style.width = bRect.width + 'px';
      slidingPill.style.transform = 'translateX(' + (bRect.left - pRect.left - 3) + 'px)';
    }

    function rebuildVisible(tier) {
      visibleTabs = [];
      visibleSlides = [];
      allTabs.forEach(function (tab) {
        var match = tab.getAttribute('data-flux-tier-tab') === tier;
        tab.style.display = match ? '' : 'none';
        if (match) visibleTabs.push(tab);
      });
      allSlides.forEach(function (slide) {
        var match = slide.getAttribute('data-flux-tier-slide') === tier;
        slide.style.display = match ? '' : 'none';
        if (match) visibleSlides.push(slide);
      });
    }

    function scrollPillToActive(tabEl) {
      if (!rimPill || !tabEl) return;
      var pRect = rimPill.getBoundingClientRect();
      var tRect = tabEl.getBoundingClientRect();
      rimPill.scrollTo({
        left: tRect.left - pRect.left + rimPill.scrollLeft - (pRect.width - tRect.width) / 2,
        behavior: 'smooth'
      });
    }

    function updateArrows() {
      if (prevBtn) prevBtn.disabled = current <= 0;
      if (nextBtn) nextBtn.disabled = current >= visibleSlides.length - 1;
    }

    function syncActive() {
      if (!visibleSlides.length) return;
      var tRect = track.getBoundingClientRect();
      var center = tRect.left + tRect.width / 2;
      var closest = 0;
      var closestDist = Infinity;
      visibleSlides.forEach(function (slide, i) {
        var r = slide.getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - center);
        if (d < closestDist) { closestDist = d; closest = i; }
      });
      if (closest !== current) {
        current = closest;
        allTabs.forEach(function (t) { t.classList.remove('is-active'); });
        allSlides.forEach(function (s) { s.classList.remove('is-active'); });
        if (visibleTabs[current]) {
          visibleTabs[current].classList.add('is-active');
          scrollPillToActive(visibleTabs[current]);
        }
        if (visibleSlides[current]) visibleSlides[current].classList.add('is-active');
        updateArrows();
      }
    }

    function scrollToSlide(idx, smooth) {
      if (idx < 0) idx = 0;
      if (idx >= visibleSlides.length) idx = visibleSlides.length - 1;
      var slide = visibleSlides[idx];
      if (!slide) return;
      var tLeft = track.getBoundingClientRect().left;
      var sLeft = slide.getBoundingClientRect().left;
      var offset = sLeft - tLeft + track.scrollLeft - (track.offsetWidth - slide.offsetWidth) / 2;
      if (smooth) track.scrollTo({ left: offset, behavior: 'smooth' });
      else track.scrollLeft = offset;
    }

    var initialized = false;

    function swapTier(tier) {
      rebuildVisible(tier);
      current = 0;
      allTabs.forEach(function (t) { t.classList.remove('is-active'); });
      allSlides.forEach(function (s) { s.classList.remove('is-active'); });
      if (visibleTabs[0]) visibleTabs[0].classList.add('is-active');
      if (visibleSlides[0]) visibleSlides[0].classList.add('is-active');
      scrollToSlide(0, false);
      updateArrows();
    }

    function applyTier(tier) {
      tierBtns.forEach(function (b) {
        var active = b.getAttribute('data-flux-tier') === tier;
        b.classList.toggle('is-active', active);
        if (active) moveTierPill(b);
      });
      if (!initialized) {
        swapTier(tier);
        initialized = true;
        root.classList.add('flux-shop--init');
        return;
      }
      root.classList.add('flux-shop--switching');
      setTimeout(function () {
        swapTier(tier);
        root.classList.remove('flux-shop--switching');
      }, 200);
    }

    allTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var idx = visibleTabs.indexOf(tab);
        if (idx !== -1) scrollToSlide(idx, true);
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { scrollToSlide(current - 1, true); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollToSlide(current + 1, true); });

    var scrollTicking = false;
    track.addEventListener('scroll', function () {
      if (!scrollTicking) {
        requestAnimationFrame(function () { syncActive(); scrollTicking = false; });
        scrollTicking = true;
      }
    }, { passive: true });

    allSlides.forEach(function (slide) {
      slide.addEventListener('click', function (e) {
        var idx = visibleSlides.indexOf(slide);
        if (idx !== -1 && idx !== current) {
          e.preventDefault();
          e.stopPropagation();
          scrollToSlide(idx, true);
        }
      }, true);
    });

    tierBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        applyTier(btn.getAttribute('data-flux-tier'));
      });
    });

    window.addEventListener('resize', function () {
      var active = root.querySelector('[data-flux-tier].is-active');
      if (active) moveTierPill(active);
    }, { passive: true });

    function addToCart(items, btn) {
      var orig = btn.textContent;
      btn.textContent = 'Adding…';
      btn.disabled = true;
      var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var secs = drawer && drawer.getSectionsToRender
        ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
      var body = { items: items };
      if (secs.length) { body.sections = secs.join(','); body.sections_url = window.location.pathname; }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.status >= 400) { btn.textContent = orig; btn.disabled = false; return; }
        btn.textContent = 'Added ✓';
        btn.disabled = false;
        try { if (drawer && drawer.renderContents && data.sections) drawer.renderContents(data); } catch (e) {}
        try {
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined')
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'flux-shop', productVariantId: items[0].id });
        } catch (e) {}
        setTimeout(function () { btn.textContent = orig; }, 2000);
      })
      .catch(function () {
        btn.textContent = 'Error';
        btn.disabled = false;
        setTimeout(function () { btn.textContent = orig; }, 3000);
      });
    }

    root.querySelectorAll('[data-shop-product]').forEach(function (el) {
      var json = el.querySelector('[data-shop-variant-json]');
      if (!json) return;
      var variants = [];
      try { variants = JSON.parse(json.textContent); } catch (e) { return; }
      var optionEls = el.querySelectorAll('[data-shop-option]');
      if (!optionEls.length) return;

      var isRadio = optionEls[0].type === 'radio';

      function getSelected() {
        var selected = {};
        if (isRadio) {
          optionEls.forEach(function (r) {
            if (r.checked) selected[r.getAttribute('data-shop-option')] = r.value;
          });
        } else {
          optionEls.forEach(function (s) {
            selected[s.getAttribute('data-shop-option')] = s.value;
          });
        }
        var ordered = [];
        var keys = Object.keys(selected).sort();
        for (var k = 0; k < keys.length; k++) ordered.push(selected[keys[k]]);
        return ordered;
      }

      function findVariant() {
        var selected = getSelected();
        for (var i = 0; i < variants.length; i++) {
          var match = true;
          for (var j = 0; j < selected.length; j++) {
            if (variants[i].options[j] !== selected[j]) { match = false; break; }
          }
          if (match) return variants[i];
        }
        return null;
      }
      function update() {
        if (isRadio) {
          el.querySelectorAll('.flux-shop__variant-btn').forEach(function (lbl) {
            var inp = lbl.querySelector('input');
            lbl.classList.toggle('is-active', inp && inp.checked);
          });
        }
        var v = findVariant();
        var priceEl = el.querySelector('[data-shop-price]');
        var wrap = el.querySelector('[data-shop-atc-wrap]');
        if (!v || !wrap) return;
        if (priceEl) priceEl.textContent = v.price;
        var old = wrap.querySelector('.sk2-shop__atc');
        if (v.available) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'sk2-btn sk2-btn--primary sk2-shop__atc';
          btn.setAttribute('data-sk2-add-to-cart', v.id);
          btn.textContent = 'Add to Cart';
          btn.addEventListener('click', function () { addToCart([{ id: v.id, quantity: 1 }], btn); });
          if (old) old.replaceWith(btn); else wrap.prepend(btn);
        } else {
          var sold = document.createElement('button');
          sold.type = 'button';
          sold.className = 'sk2-btn sk2-btn--primary sk2-shop__atc sk2-shop__sold-out';
          sold.disabled = true;
          sold.textContent = 'Sold Out';
          if (old) old.replaceWith(sold); else wrap.prepend(sold);
        }
      }
      optionEls.forEach(function (s) { s.addEventListener('change', update); });
    });

    root.querySelectorAll('[data-sk2-add-to-cart]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        addToCart([{ id: parseInt(this.getAttribute('data-sk2-add-to-cart'), 10), quantity: 1 }], this);
      });
    });

    var initial = root.querySelector('[data-flux-tier].is-active');
    applyTier(initial ? initial.getAttribute('data-flux-tier') : tierBtns[0].getAttribute('data-flux-tier'));
  }

  function initTabbedSpecs(root) {
    var tabs = root.querySelectorAll('[data-flux-spec-tab]');
    if (!tabs.length) return;
    function apply(key) {
      tabs.forEach(function (t) {
        t.classList.toggle('is-active', t.getAttribute('data-flux-spec-tab') === key);
      });
      root.querySelectorAll('[data-flux-spec-card], [data-flux-spec-row]').forEach(function (el) {
        var attr = el.getAttribute('data-flux-spec-card') || el.getAttribute('data-flux-spec-row');
        el.style.display = attr === key || attr === 'all' ? '' : 'none';
      });
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () { apply(t.getAttribute('data-flux-spec-tab')); });
    });
    var first = root.querySelector('[data-flux-spec-tab].is-active') || tabs[0];
    apply(first.getAttribute('data-flux-spec-tab'));
  }

  function initPillarsAnim(section) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var mql = window.matchMedia('(min-width: 900px)');
    var header = section.querySelector('.flux-pillars__header');
    var pillar1 = section.querySelector('.flux-pillar--1');
    var pillar2 = section.querySelector('.flux-pillar--2');
    var media1 = pillar1 && pillar1.querySelector('.flux-pillar__media');
    var media2 = pillar2 && pillar2.querySelector('.flux-pillar__media');
    var body1 = pillar1 && pillar1.querySelector('.flux-pillar__body');
    var body2 = pillar2 && pillar2.querySelector('.flux-pillar__body');
    var bg = section.querySelector('.flux-pillars__bg');
    var divider = section.querySelector('.flux-pillars__divider');
    var plusFront = divider && divider.querySelector('.flux-pillars__plus polygon:last-of-type');
    var plusBack = divider && divider.querySelector('.flux-pillars__plus polygon:first-of-type');
    var plusLines = divider ? divider.querySelectorAll('.flux-pillars__plus line') : [];
    var targetOp = parseFloat(section.style.getPropertyValue('--flux-pillars-overlay')) || 0.7;

    section.classList.add('flux-pillars--anim-ready');

    var ticking = false;

    function clamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }
    function lerp(a, b, t) { return a + (b - a) * t; }
    function prog(el, span) {
      return clamp01((window.innerHeight - el.getBoundingClientRect().top) / (window.innerHeight * span));
    }

    function tick() {
      ticking = false;
      var desk = mql.matches;
      var rad = 'round 6px';

      var op = prog(section, 0.45);
      section.style.setProperty('--flux-pillars-overlay', lerp(1, targetOp, op));

      if (bg) bg.style.opacity = clamp01(op * op);

      if (header) header.classList.toggle('is-revealed', op > 0.55);

      if (media1 && pillar1) {
        var p = prog(pillar1, 0.5);
        if (desk) {
          media1.style.clipPath = 'inset(0 0 0 ' + lerp(100, 0, p) + '% ' + rad + ')';
          media1.style.transform = 'translate(' + lerp(60, 0, p) + 'px,' + lerp(60, 0, p) + 'px)';
        } else {
          media1.style.opacity = clamp01(p * 1.5);
          media1.style.transform = 'translateY(' + lerp(30, 0, p) + 'px)';
        }
      }

      if (divider) {
        var d = prog(divider, 0.4);
        divider.style.opacity = d;
        if (plusFront) plusFront.style.strokeDashoffset = lerp(256, 0, clamp01(d / 0.7));
        plusLines.forEach(function(l) { l.style.strokeDashoffset = lerp(6, 0, clamp01((d - 0.2) / 0.6)); });
        if (plusBack) plusBack.style.strokeDashoffset = lerp(256, 0, clamp01((d - 0.3) / 0.6));
      }

      if (media2 && pillar2) {
        var p2 = prog(pillar2, 0.5);
        if (desk) {
          media2.style.clipPath = 'inset(0 ' + lerp(100, 0, p2) + '% 0 0 ' + rad + ')';
          media2.style.transform = 'translate(' + lerp(-60, 0, p2) + 'px,' + lerp(-60, 0, p2) + 'px)';
        } else {
          media2.style.opacity = clamp01(p2 * 1.5);
          media2.style.transform = 'translateY(' + lerp(30, 0, p2) + 'px)';
        }
      }

      if (body1) body1.classList.toggle('is-revealed', prog(body1, 0.5) > 0.55);
      if (body2) body2.classList.toggle('is-revealed', prog(body2, 0.5) > 0.55);
    }

    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(tick); }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    onScroll();
  }

  function initCompliance(root) {
    var tabs = root.querySelectorAll('[data-flux-compliance-tab]');
    var panels = root.querySelectorAll('[data-flux-compliance-panel]');
    if (!tabs.length || !panels.length) return;
    function apply(idx) {
      tabs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      panels.forEach(function (p, i) {
        var on = i === idx;
        p.classList.toggle('is-active', on);
        var v = p.querySelector('video');
        if (!v) return;
        if (on) { try { v.currentTime = 0; v.play(); } catch (e) {} }
        else v.pause();
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { apply(i); });
    });
  }

  function initRatingsScroll(section) {
    var bgLayers = section.querySelectorAll('[data-flux-ratings-bg]');
    var cards = section.querySelectorAll('[data-flux-ratings-card]');
    var ring = section.querySelector('.flux-ratings__focus-ring');
    var intro = section.querySelector('.flux-ratings__intro');
    var inner = section.querySelector('.flux-ratings__inner');
    var videoWrap = section.querySelector('[data-flux-ratings-video]');
    var videoPlayer = videoWrap ? videoWrap.querySelector('.flux-ratings__video-player') : null;
    if (!cards.length) return;

    var activeIdx = 0;
    var onVideo = false;
    var ticking = false;
    var revealed = false;
    var ringRevealed = false;
    var blinkTimer = null;
    var expandTimer = null;
    var pad = 10;

    section.classList.add('flux-ratings--anim-ready');

    function offsetIn(el, ancestor) {
      var top = 0, left = 0;
      while (el && el !== ancestor) {
        top += el.offsetTop;
        left += el.offsetLeft;
        el = el.offsetParent;
      }
      return { top: top, left: left };
    }

    function positionRingOn(el) {
      if (!ring || !el) return;
      var pos = offsetIn(el, inner);
      ring.style.top = (pos.top - pad) + 'px';
      ring.style.height = (el.offsetHeight + pad * 2) + 'px';
      ring.style.left = (pos.left - pad) + 'px';
      ring.style.right = (inner.offsetWidth - pos.left - el.offsetWidth - pad) + 'px';
    }

    function positionRing(idx) {
      positionRingOn(cards[idx]);
    }

    function collapseRing() {
      if (!ring || !cards[0]) return;
      var pos = offsetIn(cards[0], inner);
      var centerTop = pos.top + (cards[0].offsetHeight - 100) / 2;
      var centerLeft = pos.left + (cards[0].offsetWidth - 100) / 2;
      ring.style.top = centerTop + 'px';
      ring.style.height = '100px';
      ring.style.left = centerLeft + 'px';
      ring.style.right = (inner.offsetWidth - centerLeft - 100) + 'px';
      ring.classList.remove('is-revealed');
    }

    collapseRing();

    function setActive(idx) {
      if (idx === activeIdx && !onVideo) return;
      bgLayers.forEach(function (layer) {
        layer.classList.toggle('is-active',
          parseInt(layer.getAttribute('data-flux-ratings-bg'), 10) === idx);
      });
      activeIdx = idx;
      onVideo = false;
      positionRing(idx);
    }

    function setVideo() {
      if (onVideo) return;
      onVideo = true;
      positionRingOn(videoPlayer || videoWrap);
    }

    function reveal() {
      revealed = true;
      if (intro) intro.classList.add('is-revealed');

      blinkTimer = setTimeout(function () {
        if (ring) ring.classList.add('is-revealed');
        blinkTimer = setTimeout(function () {
          if (ring) ring.classList.remove('is-revealed');
          blinkTimer = setTimeout(function () {
            if (ring) ring.classList.add('is-revealed');
            blinkTimer = setTimeout(function () {
              if (ring) ring.classList.remove('is-revealed');
              blinkTimer = setTimeout(function () {
                if (ring) ring.classList.add('is-revealed');
                expandTimer = setTimeout(function () {
              var trigger = window.innerHeight * 0.45;
              var best = 0;
              for (var i = 0; i < cards.length; i++) {
                if (cards[i].getBoundingClientRect().top <= trigger) best = i;
              }
              activeIdx = best;
              onVideo = false;
              if (videoWrap && videoWrap.getBoundingClientRect().top <= window.innerHeight * 0.45) {
                onVideo = true;
                positionRingOn(videoPlayer || videoWrap);
              } else {
                if (ring) positionRing(best);
                bgLayers.forEach(function (layer) {
                  layer.classList.toggle('is-active',
                    parseInt(layer.getAttribute('data-flux-ratings-bg'), 10) === best);
                });
              }
              ringRevealed = true;
            }, 150);
          }, 60);
        }, 60);
      }, 60);
    }, 60);
  }, 500);
    }

    function unrevel() {
      revealed = false;
      ringRevealed = false;
      if (blinkTimer) { clearTimeout(blinkTimer); blinkTimer = null; }
      if (expandTimer) { clearTimeout(expandTimer); expandTimer = null; }
      if (intro) intro.classList.remove('is-revealed');
      collapseRing();
      activeIdx = 0;
    }

    function tick() {
      ticking = false;
      var sRect = section.getBoundingClientRect();
      var inView = sRect.top < window.innerHeight * 0.5 && sRect.bottom > 0;

      if (!revealed && inView) {
        reveal();
      }

      if (!ringRevealed) return;

      var trigger = window.innerHeight * 0.45;
      var best = 0;
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].getBoundingClientRect().top <= trigger) best = i;
      }

      if (videoWrap && videoWrap.getBoundingClientRect().top <= trigger) {
        setVideo();
      } else {
        setActive(best);
      }
    }

    function onScroll() {
      if (!ticking) { ticking = true; requestAnimationFrame(tick); }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      if (!ringRevealed) return;
      if (onVideo) positionRingOn(videoPlayer || videoWrap);
      else positionRing(activeIdx);
    }, { passive: true });
    onScroll();
  }

  function formatMoney(cents, fmt) {
    var amount = (cents / 100).toFixed(2);
    if (!fmt) return '$' + amount;
    return fmt.replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  function updatePanelTotal(panel) {
    if (!panel) return;
    var setBtn = panel.querySelector('[data-gr-add-both]');
    if (!setBtn) return;
    var totalEl = setBtn.querySelector('[data-gr-set-total]');
    var tires = panel.querySelectorAll('[data-gr-tire]');
    var total = 0;
    var allAvail = tires.length > 0;
    tires.forEach(function (tire) {
      var atc = tire.querySelector('[data-gr-tire-atc]');
      var cents = parseInt(tire.getAttribute('data-gr-tire-cents') || '0', 10);
      total += isNaN(cents) ? 0 : cents;
      if (!atc || atc.disabled) allAvail = false;
    });
    if (totalEl) {
      totalEl.setAttribute('data-gr-set-cents', String(total));
      totalEl.textContent = formatMoney(total, setBtn.getAttribute('data-gr-money-format'));
    }
    setBtn.disabled = !allAvail;
  }

  function initTireOptions() {
    document.querySelectorAll('[data-gr-tire]').forEach(function (tire) {
      var optionRadios = tire.querySelectorAll('[data-gr-tire-option]');
      if (!optionRadios.length) return;

      var json = tire.querySelector('[data-gr-tire-variants]');
      var atc = tire.querySelector('[data-gr-tire-atc]');
      var atcLabel = atc && atc.querySelector('[data-gr-btn-label]');
      var priceEl = tire.querySelector('[data-gr-tire-price]');
      var imgEl = tire.querySelector('[data-gr-tire-img]');
      var position = tire.getAttribute('data-gr-tire-position') || 'wheel';
      var posLabel = position.charAt(0).toUpperCase() + position.slice(1);
      if (!json || !atc) return;

      var variants = [];
      try { variants = JSON.parse(json.textContent); } catch (e) { return; }

      function findVariant() {
        var selected = {};
        optionRadios.forEach(function (r) {
          if (r.checked) selected[r.getAttribute('data-gr-tire-option')] = r.value;
        });
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var match = true;
          for (var key in selected) {
            if (v.options[parseInt(key, 10)] !== selected[key]) { match = false; break; }
          }
          if (match) return v;
        }
        return null;
      }

      function update() {
        optionRadios.forEach(function (r) {
          var btn = r.closest('.gr-setup__size-btn');
          if (btn) btn.classList.toggle('is-active', r.checked);
        });

        var match = findVariant();
        if (match) {
          atc.setAttribute('data-gr-tire-atc', match.id);
          tire.setAttribute('data-gr-tire-cents', String(match.priceCents || 0));
          if (priceEl) priceEl.textContent = match.price;
          if (imgEl && match.image) imgEl.src = match.image;
          atc.disabled = !match.available;
          var isFlux = tire.closest('.flux-setup');
          if (atcLabel) atcLabel.textContent = match.available ? (isFlux ? 'Add to Cart' : 'Add ' + posLabel + ' to Cart') : 'Sold Out';
        } else {
          atc.disabled = true;
          if (atcLabel) atcLabel.textContent = 'Unavailable';
        }
        updatePanelTotal(tire.closest('[data-gr-option]'));
      }

      optionRadios.forEach(function (r) {
        r.addEventListener('change', update);
      });
    });
  }

  function initSpecsScroll() {
    var mobileQuery = window.matchMedia('(max-width: 749px)');
    document.querySelectorAll('[data-flux-specs-scroll]').forEach(function (el) {
      var wrap = el.parentElement;
      var section = el.closest('[data-flux-term]');
      var hint = section ? section.querySelector('[data-flux-term-scroll-hint]') : null;
      var elVisible = el.offsetParent !== null;
      window.addEventListener('resize', function () { elVisible = el.offsetParent !== null; });
      var prevSL = 0;
      var lastDir = 0;
      var dirChangePos = 0;
      var DIR_THRESHOLD = 30;
      var modelAnimating = false;
      function update() {
        var sl = el.scrollLeft;
        el.classList.toggle('is-scrolled', sl > 2);
        var atEnd = sl + el.clientWidth >= el.scrollWidth - 2;
        if (wrap) wrap.classList.toggle('is-scrolled-end', atEnd);
        if (hint && elVisible) {
          var needsScroll = el.scrollWidth > el.clientWidth + 4;
          hint.classList.toggle('is-hidden', !needsScroll || sl > 2);
        }
        if (mobileQuery.matches) {
          var dir = sl > prevSL ? 1 : (sl < prevSL ? -1 : 0);
          if (dir !== 0 && dir !== lastDir) {
            dirChangePos = sl;
            lastDir = dir;
          }
          if (lastDir === -1 && dirChangePos - sl > DIR_THRESHOLD && sl > 10) {
            if (!el.classList.contains('is-model-sticky')) {
              var cells = el.querySelectorAll('.flux-specs-term__cell--model, .flux-specs-term__col--model, .flux-specs-term__comment-text');
              cells.forEach(function (c) { c.style.transition = 'none'; });
              el.classList.add('is-model-sticky');
              el.classList.add('is-model-hide');
              if (cells[0]) getComputedStyle(cells[0]).transform; // flush -100% before enabling transition
              cells.forEach(function (c) { c.style.transition = ''; });
              el.classList.remove('is-model-hide');
              modelAnimating = true;
              setTimeout(function () {
                modelAnimating = false;
                if (el.scrollLeft <= 2) {
                  el.classList.remove('is-model-sticky');
                  lastDir = 0;
                }
              }, 300);
            }
          } else if (lastDir === 1 && sl - dirChangePos > DIR_THRESHOLD) {
            if (el.classList.contains('is-model-sticky') && !el.classList.contains('is-model-hide')) {
              el.classList.add('is-model-hide');
              modelAnimating = true;
              setTimeout(function () {
                el.classList.remove('is-model-sticky');
                el.classList.remove('is-model-hide');
                modelAnimating = false;
              }, 300);
            }
          }
          if (sl <= 2 && !modelAnimating) {
            el.classList.remove('is-model-sticky');
            el.classList.remove('is-model-hide');
            lastDir = 0;
          }
        }
        prevSL = sl;
      }
      el.addEventListener('scroll', update);
      update();
    });
  }

  /* ── Terminal specs: descramble + expand entrance ── */

  var SCRAMBLE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789_./\\-';

  function scrambleText(el, done, opts) {
    if (el._scrambleCancel) el._scrambleCancel();
    var cancelled = false;
    el._scrambleCancel = function() { cancelled = true; };
    var target = el.getAttribute('data-flux-term-scramble');
    if (!target) { el._scrambleCancel = null; if (done) done(); return; }
    opts = opts || {};
    var len = target.length;
    var cursor = 0;
    var scrambleWidth = opts.fast ? 3 : 4;
    var delay = opts.fast ? 32 : 40;
    var ticksPerChar = opts.fast ? 2 : 3;
    var tickCount = 0;
    var halfFired = false;

    function tick() {
      if (cancelled) return;
      var before = '';
      var scramble = '';
      for (var i = 0; i < len; i++) {
        if (i < cursor) {
          before += target[i];
        } else if (target[i] === ' ' && i <= cursor + scrambleWidth) {
          scramble += ' ';
        } else if (i < cursor + scrambleWidth) {
          scramble += SCRAMBLE_CHARS[Math.floor(Math.random() * SCRAMBLE_CHARS.length)];
        }
      }
      var cursorHtml = '';
      if (!opts.noCursor) {
        var pulse = Math.sin(Date.now() / 90) * 0.5 + 0.5;
        var r = Math.round(26 + (255 - 26) * pulse);
        var g = Math.round(26 + (255 - 26) * pulse);
        var b = Math.round(31 + (255 - 31) * pulse);
        cursorHtml = '<span style="display:inline-block;width:0;overflow:visible"><span class="flux-term-cursor" style="background:rgb(' + r + ',' + g + ',' + b + ')">&nbsp;</span></span>';
      }
      el.innerHTML = before + scramble + cursorHtml;
      tickCount++;
      if (tickCount % ticksPerChar === 0) cursor++;
      while (cursor < len && target[cursor] === ' ') cursor++;

      if (!halfFired && cursor >= Math.ceil(len / 2)) {
        halfFired = true;
        if (opts.onHalf) opts.onHalf();
      }
      if (cursor >= len) { el._scrambleCancel = null; el.textContent = target; if (done) done(); }
      else setTimeout(tick, delay);
    }

    requestAnimationFrame(tick);
  }

  function initTerminalAnim() {
    document.querySelectorAll('[data-flux-term]').forEach(function (section) {
      var wheelsBody = section.querySelector('[data-flux-term-dataset="wheels"]');
      var rimsBody = section.querySelector('[data-flux-term-dataset="rims"]');
      var rows = wheelsBody ? wheelsBody.querySelectorAll('[data-flux-term-row]') : section.querySelectorAll('[data-flux-term-row]');
      var scrambleEls = section.querySelectorAll('[data-flux-term-scramble]');
      var filenameEl = section.querySelector('.flux-specs-term__filename');
      var badgeEl = section.querySelector('.flux-specs-term__badge');
      var statusLines = section.querySelector('[data-flux-term-status-lines]');
      var spinnerEl = section.querySelector('[data-flux-term-spinner]');
      var spinnerDots = spinnerEl ? spinnerEl.querySelectorAll('.flux-specs-term__spinner-dot') : [];
      var spinnerTimer = null;
      function startSpinner() {
        if (!spinnerDots.length) return;
        spinnerTimer = setInterval(function () {
          spinnerDots.forEach(function (dot) {
            if (Math.random() < 0.3) {
              dot.classList.toggle('is-lit');
            }
          });
        }, 100);
      }
      function stopSpinner() {
        clearInterval(spinnerTimer); spinnerTimer = null;
        spinnerDots.forEach(function (dot) { dot.classList.remove('is-lit'); });
      }
      var fired = false;
      var header = section.querySelector('.flux-specs-term__header');
      section.classList.add('flux-specs-term--anim-ready');
      var modelOriginalTexts = [];
      rows.forEach(function(r) {
        var mv = r.querySelector('.flux-specs-term__cell--model .flux-specs-term__val');
        modelOriginalTexts.push(mv ? mv.textContent : '');
      });

      function animateRow(row, onDone) {
        row.classList.add('is-visible');
        var modelVal = row.querySelector('.flux-specs-term__cell--model .flux-specs-term__val');
        var dataCells = row.querySelectorAll('.flux-specs-term__cell:not(.flux-specs-term__cell--model)');

        if (!modelVal) {
          dataCells.forEach(function (c) { c.classList.add('is-visible'); });
          if (onDone) onDone();
          return;
        }

        var realText = modelVal.textContent;
        modelVal.textContent = '';
        modelVal.setAttribute('data-flux-term-scramble', realText);

        var colsStarted = false;
        var colsDone = false;
        var scrambleDone = false;
        function startCols() {
          if (colsStarted) return;
          colsStarted = true;
          var ci = 0;
          function nextCol() {
            if (ci < dataCells.length) {
              dataCells[ci].classList.add('is-visible');
              ci++;
              setTimeout(nextCol, 20);
            } else {
              colsDone = true;
              if (scrambleDone && onDone) onDone();
            }
          }
          nextCol();
        }

        scrambleText(modelVal, function () {
          modelVal.removeAttribute('data-flux-term-scramble');
          scrambleDone = true;
          startCols();
          if (colsDone && onDone) onDone();
        }, { fast: true, onHalf: startCols });
      }

      // Reserve section height for active table to prevent CLS
      var bleed = section.querySelector('.flux-specs-term__bleed');
      if (bleed && wheelsBody) {
        bleed.style.minHeight = bleed.scrollHeight + 'px';
      }
      function releaseHeight() {
        if (!bleed) return;
        bleed.style.minHeight = bleed.scrollHeight + 'px';
      }

      // Toggle between wheels and rims
      var toggleBtns = section.querySelectorAll('[data-flux-term-tab]');
      var pill = section.querySelector('[data-flux-term-pill]');

      function movePill(btn) {
        if (!pill || !btn) return;
        var toggleRect = btn.parentElement.getBoundingClientRect();
        var btnRect = btn.getBoundingClientRect();
        var offset = btnRect.left - toggleRect.left - 3;
        pill.style.width = btnRect.width + 'px';
        pill.style.transform = 'translateX(' + offset + 'px)';
      }
      // Position pill on first active button
      toggleBtns.forEach(function (b) { if (b.classList.contains('is-active')) movePill(b); });

      var bgLayers = section.querySelectorAll('[data-flux-term-bg]');
      function swapBg(tab) {
        bgLayers.forEach(function (bg) {
          bg.classList.toggle('is-active', bg.getAttribute('data-flux-term-bg') === tab);
        });
      }

      toggleBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var tab = btn.getAttribute('data-flux-term-tab');
          toggleBtns.forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          movePill(btn);
          swapBg(tab);

          if (tab === 'rims' && rimsBody) {
            wheelsBody.style.display = 'none';
            rimsBody.style.display = '';
            rimsBody.querySelectorAll('.flux-specs-term__comment-row, .flux-specs-term__row').forEach(function (r) { r.style.visibility = 'visible'; r.style.opacity = '1'; });
            var rimRows = rimsBody.querySelectorAll('.flux-specs-term__row');
            rimRows.forEach(function (r) { r.querySelectorAll('.flux-specs-term__cell').forEach(function (c) { c.style.opacity = '1'; }); });
            if (filenameEl) filenameEl.textContent = 'flux_rims.csv';
            if (badgeEl) badgeEl.textContent = rimRows.length + ' rims';
            var rlines = rimsBody.querySelectorAll('.flux-specs-term__comment-row, .flux-specs-term__row').length;
            if (statusLines) statusLines.textContent = rlines + ' lines';
          } else if (wheelsBody) {
            if (rimsBody) rimsBody.style.display = 'none';
            wheelsBody.style.display = '';
            if (filenameEl) filenameEl.textContent = 'flux_wheels.csv';
            var wheelDataRows = wheelsBody.querySelectorAll('.flux-specs-term__row');
            if (badgeEl) badgeEl.textContent = wheelDataRows.length + ' wheels';
          }

          var scrollHint = section.querySelector('[data-flux-term-scroll-hint]');
          var activeBody = (tab === 'rims' && rimsBody) ? rimsBody : wheelsBody;
          if (scrollHint && activeBody) {
            requestAnimationFrame(function () {
              var needsScroll = activeBody.scrollWidth > activeBody.clientWidth + 4;
              scrollHint.classList.toggle('is-hidden', !needsScroll || activeBody.scrollLeft > 2);
            });
          }
        });
      });

      function resetAnim() {
        fired = false;
        section.classList.remove('is-visible', 'is-expanded', 'is-rows-done');
        if (header) header.classList.remove('is-revealed');
        stopSpinner();

        scrambleEls.forEach(function(el) {
          if (el._scrambleCancel) el._scrambleCancel();
          el.textContent = '';
        });

        rows.forEach(function(r, i) {
          r.classList.remove('is-visible');
          var mv = r.querySelector('.flux-specs-term__cell--model .flux-specs-term__val');
          if (mv) {
            if (mv._scrambleCancel) mv._scrambleCancel();
            mv.removeAttribute('data-flux-term-scramble');
            mv.textContent = modelOriginalTexts[i];
          }
          r.querySelectorAll('.flux-specs-term__cell').forEach(function(c) { c.classList.remove('is-visible'); });
        });

        if (rimsBody) {
          rimsBody.style.display = 'none';
          rimsBody.querySelectorAll('.flux-specs-term__comment-row, .flux-specs-term__row').forEach(function(r) { r.style.visibility = ''; r.style.opacity = ''; });
          rimsBody.querySelectorAll('.flux-specs-term__cell').forEach(function(c) { c.style.opacity = ''; });
        }
        if (wheelsBody) wheelsBody.style.display = '';
        toggleBtns.forEach(function(b) {
          b.classList.toggle('is-active', b.getAttribute('data-flux-term-tab') === 'wheels');
          if (b.classList.contains('is-active')) movePill(b);
        });
        swapBg('wheels');
        if (filenameEl) filenameEl.textContent = '';
        if (badgeEl) badgeEl.textContent = '';

        if (bleed && wheelsBody) {
          bleed.style.minHeight = bleed.scrollHeight + 'px';
        }
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.35 && !fired) {
            fired = true;

            if (header) header.classList.add('is-revealed');
            section.classList.add('is-visible');

            setTimeout(function () {
              if (!fired) return;
              scrambleEls.forEach(function (el) { scrambleText(el, null, { noCursor: true }); });

              section.classList.add('is-expanded');
              startSpinner();
              var ri = 0;
              var pendingRows = 0;
              function nextRow() {
                if (ri >= rows.length) {
                  if (pendingRows <= 0) {
                    stopSpinner();
                    section.classList.add('is-rows-done');
                    releaseHeight();
                  }
                  return;
                }
                var row = rows[ri];
                ri++;
                var isComment = row.classList.contains('flux-specs-term__comment-row');
                if (isComment) {
                  row.classList.add('is-visible');
                  setTimeout(nextRow, 50);
                } else {
                  pendingRows++;
                  animateRow(row, function () {
                    pendingRows--;
                    if (ri >= rows.length && pendingRows <= 0) {
                      stopSpinner();
                      section.classList.add('is-rows-done');
                      releaseHeight();
                    }
                  });
                  setTimeout(nextRow, 80);
                }
              }
              setTimeout(nextRow, 150);
            }, 400);
          } else if (!entry.isIntersecting && fired) {
            resetAnim();
          }
        });
      }, { threshold: [0, 0.35] });

      observer.observe(section);
    });
  }

  function initFluxExploded(exploded) {
    var exTicking = false;
    var exVisible = false;

    var exFocusData = [];
    var exFocusEl = exploded.querySelector('[data-flux-exploded-focus]');
    if (exFocusEl) {
      try { exFocusData = JSON.parse(exFocusEl.textContent); } catch (e) {}
    }
    var exCount = exFocusData.length || 1;
    var exDefault = { x: 50, y: 50 };
    var exImg = exploded.querySelector('.flux-exploded__hub-img:not(.flux-exploded__hub-img--reveal)');
    var exHlDot = exploded.querySelector('.flux-exploded__hl-dot');
    var exHlBack = exploded.querySelector('.flux-exploded__hl-back');
    var exSticky = exploded.querySelector('.flux-exploded__sticky');
    var exFeatures = exploded.querySelectorAll('.flux-exploded__feature');
    var exLastActiveIdx = -1;
    var exLastDeadzone = false;
    var exMobile = window.matchMedia('(max-width: 767px)').matches;

    function exClamp01(v) { return v < 0 ? 0 : v > 1 ? 1 : v; }

    function updateExploded() {
      exTicking = false;
      if (!exVisible) return;

      var ih = window.innerHeight;
      var rect = exploded.getBoundingClientRect();
      var scrollRange = exploded.offsetHeight - ih;
      if (scrollRange <= 0) return;
      var progress = exClamp01(-rect.top / scrollRange);

      var feature = progress * exCount;
      exploded.style.setProperty('--feature', feature);

      var reveal = exClamp01(feature / 0.4);
      exploded.style.setProperty('--reveal', reveal);

      var revealScale = 1.0 + reveal * 0.2;
      exploded.style.setProperty('--hub-scale', revealScale);

      var activeIdx = Math.max(0, Math.min(Math.floor(feature), exCount - 1));
      var t = feature - activeIdx;
      var inDeadzone = feature >= 0.25 && t >= 0.25 && t < 0.95;

      if (activeIdx !== exLastActiveIdx) {
        var pt = exFocusData[activeIdx] || exDefault;
        exploded.style.setProperty('--hl-x', pt.x);
        exploded.style.setProperty('--hl-y', pt.y);

        if (exMobile) {
          var vw = window.innerWidth;
          var hubW = vw * 1.6;
          var txIdeal = hubW * (0.5 - pt.x / 100);
          var maxTx = (hubW - vw) / 2 * 1.3;
          var txMobile = Math.max(-maxTx, Math.min(maxTx, txIdeal));
          exploded.style.setProperty('--hub-tx-mobile', txMobile + 'px');
        }

        exFeatures.forEach(function (f, i) {
          f.classList.toggle('is-past', i < activeIdx);
        });
        exLastActiveIdx = activeIdx;
      }

      if (inDeadzone !== exLastDeadzone) {
        if (exHlDot) exHlDot.classList.toggle('is-visible', inDeadzone);
        if (exHlBack) exHlBack.classList.toggle('is-active', inDeadzone);
        exLastDeadzone = inDeadzone;
      }
    }

    new IntersectionObserver(
      function (entries) {
        exVisible = entries[0].isIntersecting;
        if (exVisible) updateExploded();
      },
      { rootMargin: '200px 0px' }
    ).observe(exploded);

    window.addEventListener('scroll', function () {
      if (!exTicking) {
        requestAnimationFrame(updateExploded);
        exTicking = true;
      }
    });

    var exInitRect = exploded.getBoundingClientRect();
    exVisible = exInitRect.bottom > -200 && exInitRect.top < window.innerHeight + 200;
    updateExploded();

    var exResizeRaf = false;
    window.addEventListener('resize', function () {
      if (exResizeRaf) return;
      exResizeRaf = true;
      requestAnimationFrame(function () {
        exResizeRaf = false;
        exMobile = window.matchMedia('(max-width: 767px)').matches;
        if (!exMobile) exploded.style.removeProperty('--hub-tx-mobile');
        exLastActiveIdx = -1;
        var r = exploded.getBoundingClientRect();
        exVisible = r.bottom > -200 && r.top < window.innerHeight + 200;
        updateExploded();
      });
    });
  }

  ready(function () {
    document.querySelectorAll('[data-flux-exploded]').forEach(initFluxExploded);
    document.querySelectorAll('[data-flux-pillars-anim]').forEach(initPillarsAnim);
    document.querySelectorAll('[data-flux-rim-shop]').forEach(initRimShop);
    document.querySelectorAll('[data-flux-tabbed-specs], [data-flux-spec-sheet]').forEach(initTabbedSpecs);
    document.querySelectorAll('[data-flux-compliance]').forEach(initCompliance);
    document.querySelectorAll('[data-flux-ratings-scroll]').forEach(initRatingsScroll);
    initTireOptions();
    initSpecsScroll();
    initTerminalAnim();

    document.querySelectorAll('[data-flux-autoplay-on-scroll]').forEach(function (video) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            video.play();
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.05 });
      observer.observe(video);
    });
  });
})();
